import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
} from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { financialItemStyles } from "./styles/financialItemStyle";
import TableContainer from "@material-ui/core/TableContainer";
import "../Print.css";
type DenominationDataProps = {
  denominationData: Array<object>;
  denominationTotal: number;
  source: string;
};

export const Denomination: FunctionComponent<DenominationDataProps> = ({
  denominationData,
  denominationTotal,
  source,
}) => {
  const classes = financialItemStyles();
  return (
    <Grid container style={{ paddingTop: "2.4em" }}>
      <Grid item xs={12}>
        <TableContainer>
          <Grid container>
            <Grid item lg={12}>
              <Typography className={classes.title}>Denomination</Typography>
            </Grid>
          </Grid>
          <Table
            size="small"
            aria-label="a dense table"
            className={source === "print" ? classes.table : ""}
          >
            <TableHead className={classes.tableRow}>
              <TableRow>
                <TableCell
                  align="left"
                  className={classes.headColor}
                  component="th"
                  scope="row"
                  style={{ width: "50%" }}
                ></TableCell>

                <TableCell align="right" className={classes.headCell}>
                  Bills
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.headCell}
                  style={{ width: "25%" }}
                >
                  Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {denominationData &&
                denominationData.map((data: any) => (
                  <TableRow>
                    <TableCell align="left" className={classes.headColor}>
                      {data.denomination_code}
                    </TableCell>
                    <TableCell align="right" className={classes.headColor}>
                      {data.denomination_count ? data.denomination_count : "0"}
                    </TableCell>
                    <TableCell align="right" className={classes.headColor}>
                      {data.denomination_amount
                        ? data.denomination_amount
                        : "0.00"}
                    </TableCell>
                  </TableRow>
                ))}
              <TableRow>
                <TableCell align="left" className={classes.headCell}>
                  Total
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.headCell}
                ></TableCell>
                <TableCell align="right" className={classes.headCell}>
                  {denominationTotal ? denominationTotal : "0.00"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
